import React from "react";

function Eye({ className }) {
  return (
    <svg
      viewBox="0 0 17 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.63477 2.75781V2.78516C10.3301 2.78516 11.6973 4.15234 11.6973 5.82031C11.6973 7.51562 10.3301 8.88281 8.63477 8.88281C6.93945 8.88281 5.57227 7.51562 5.57227 5.82031C5.57227 5.51953 5.62695 5.24609 5.70898 4.97266C5.90039 5.10938 6.17383 5.16406 6.44727 5.16406C7.26758 5.16406 7.97852 4.48047 7.97852 3.63281C7.95117 3.38672 7.89648 3.11328 7.75977 2.89453C8.0332 2.8125 8.33398 2.78516 8.63477 2.75781ZM16.4004 5.4375C16.4551 5.54688 16.4824 5.68359 16.4824 5.84766C16.4824 5.98438 16.4551 6.12109 16.4004 6.23047C14.9238 9.12891 11.9707 11.0703 8.63477 11.0703C5.27148 11.0703 2.31836 9.12891 0.841797 6.23047C0.787109 6.12109 0.759766 5.98438 0.759766 5.82031C0.759766 5.68359 0.787109 5.54688 0.841797 5.4375C2.31836 2.53906 5.27148 0.570312 8.63477 0.570312C11.9707 0.570312 14.9238 2.53906 16.4004 5.4375ZM8.63477 9.75781C11.3145 9.75781 13.8027 8.25391 15.1152 5.82031C13.8027 3.38672 11.3145 1.88281 8.63477 1.88281C5.92773 1.88281 3.43945 3.38672 2.12695 5.82031C3.43945 8.25391 5.92773 9.75781 8.63477 9.75781Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Eye;
